import { render, staticRenderFns } from "./myTicketTimeAllocation.vue?vue&type=template&id=3af39bbb&"
import script from "./myTicketTimeAllocation.vue?vue&type=script&lang=js&"
export * from "./myTicketTimeAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports